import { gql } from "@apollo/client";

export const GET_AD_OBJECT_NAMES = gql`
  query GetAdObjectNames(
    $searchQuery: String!
    $limit: Int
    $levels: [String!]
  ) {
    me {
      adObjectNames(searchQuery: $searchQuery, limit: $limit, levels: $levels) {
        level
        name
      }
    }
  }
`;
